module.exports = __webpack_public_path__ + "static/media/background.286b1771.png";